var render = function () {
  var _vm$booking$customerI, _vm$booking, _vm$booking2, _vm$booking3, _vm$booking4, _vm$booking5, _vm$booking6, _vm$booking7, _vm$booking8, _vm$booking9, _vm$booking10, _vm$booking10$custome;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "flat": "",
      "min-width": _vm.width,
      "loading": _vm.isLoading
    }
  }, [_vm.bookingCancelled ? _c('v-alert', {
    attrs: {
      "tile": true,
      "min-width": _vm.width,
      "type": "warning"
    }
  }, [_c('v-row', [_vm._v(" " + _vm._s(_vm.$t("components.booking.BookingDetailCard.bookingCancelledAlertText")) + " ")])], 1) : _vm._e(), _c('v-card-title', [_vm.booking && _vm.booking.customerInformation ? _c('div', [_vm._v(" " + _vm._s(_vm.booking.customerInformation.firstName) + " " + _vm._s(_vm.booking.customerInformation.lastName) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.serviceName) + " - " + _vm._s(_vm.resourceName))]), _c('v-spacer'), _c('template-dialog', {
    ref: "templateDialog",
    attrs: {
      "icon": "mdi-email-outline",
      "context": _vm.context,
      "partnerId": _vm.partner._id,
      "to": [(_vm$booking$customerI = _vm.booking.customerInformation) === null || _vm$booking$customerI === void 0 ? void 0 : _vm$booking$customerI.email],
      "from": [_vm.partner]
    }
  }), !_vm.isEdit && !_vm.bookingCancelled ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isEdit = true;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm.bookingCancelled ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isDeleteDialogActive = true;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-delete-outline")])], 1) : _vm._e()], 1), _c('v-card-subtitle', [_vm._v(" Erstellt: " + _vm._s(_vm._f("simpleDoubleDigitDate")((_vm$booking = _vm.booking) === null || _vm$booking === void 0 ? void 0 : _vm$booking.timestamp.created)) + " ")]), _vm.isEdit ? _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('booking-form', {
    attrs: {
      "resources": _vm.resources
    },
    model: {
      value: _vm.updateBookingDto,
      callback: function callback($$v) {
        _vm.updateBookingDto = $$v;
      },
      expression: "updateBookingDto"
    }
  })], 1) : _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-n8",
    attrs: {
      "label": _vm.$t('views.booking.BookingForm.date'),
      "value": _vm.startDateString,
      "type": "date",
      "outlined": "",
      "readonly": !_vm.isEdit
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('views.booking.BookingForm.startTime'),
      "value": _vm.startTimeString,
      "type": "time",
      "outlined": "",
      "readonly": !_vm.isEdit
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [!_vm.isEdit ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('views.booking.BookingForm.endTime'),
      "value": _vm.endTimeString,
      "outlined": "",
      "readonly": ""
    }
  }) : _vm._e()], 1)], 1), _vm.isEdit ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.duration'),
      "value": _vm.booking.duration,
      "type": "time",
      "outlined": ""
    }
  }) : _vm._e(), (_vm$booking2 = _vm.booking) !== null && _vm$booking2 !== void 0 && _vm$booking2.customerInformation ? _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.email'),
      "value": (_vm$booking3 = _vm.booking) === null || _vm$booking3 === void 0 ? void 0 : _vm$booking3.customerInformation.email,
      "type": "email",
      "outlined": "",
      "readonly": !_vm.isEdit
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.phone'),
      "value": (_vm$booking4 = _vm.booking) === null || _vm$booking4 === void 0 ? void 0 : _vm$booking4.customerInformation.phone,
      "type": "phone",
      "outlined": "",
      "readonly": !_vm.isEdit
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.numberPlate'),
      "value": (_vm$booking5 = _vm.booking) === null || _vm$booking5 === void 0 ? void 0 : _vm$booking5.customerInformation.numberPlate,
      "outlined": "",
      "readonly": !_vm.isEdit
    }
  })], 1) : _vm._e(), (_vm$booking6 = _vm.booking) !== null && _vm$booking6 !== void 0 && _vm$booking6.attachments && (_vm$booking7 = _vm.booking) !== null && _vm$booking7 !== void 0 && _vm$booking7.attachments.length ? _c('booking-attachment-list', {
    staticStyle: {
      "max-width": "600px"
    },
    attrs: {
      "attachments": _vm.booking.attachments
    }
  }) : _vm._e(), (_vm$booking8 = _vm.booking) !== null && _vm$booking8 !== void 0 && _vm$booking8.bookingInformation ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.notes'),
      "value": (_vm$booking9 = _vm.booking) === null || _vm$booking9 === void 0 ? void 0 : _vm$booking9.bookingInformation.notes,
      "outlined": "",
      "readonly": !_vm.isEdit
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.resource'),
      "value": _vm.resourceName,
      "outlined": "",
      "readonly": !_vm.isEdit,
      "append-outer-icon": "mdi-open-in-new"
    },
    on: {
      "click:append-outer": _vm.goToResource
    }
  }), _vm.booking.serviceId ? _c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.service'),
      "value": _vm.serviceName,
      "outlined": "",
      "readonly": !_vm.isEdit,
      "append-outer-icon": "mdi-open-in-new"
    },
    on: {
      "click:append-outer": _vm.goToService
    }
  }) : _vm._e()], 1)], 1), _vm.isEdit ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "elevation": "0",
      "color": "success",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.onUpdateBookingClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.booking.BookingDetailCard.save")) + " ")])], 1) : _vm._e(), _c('v-card-actions', [!_vm.isEdit ? _c('v-btn', {
    attrs: {
      "block": "",
      "elevation": "0",
      "color": "error"
    },
    on: {
      "click": function click($event) {
        _vm.isDeleteDialogActive = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.booking.BookingDetailCard.delete")) + " ")]) : _c('v-btn', {
    attrs: {
      "block": "",
      "elevation": "0",
      "outlined": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        _vm.isEdit = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("abort")) + " ")])], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "title": _vm.$t('views.booking.BookingTable.confirmDeleteTitle'),
      "subtitle": _vm.$t('views.booking.BookingTable.confirmDeleteSubtitle'),
      "leftLoading": _vm.isDeleteDialogLoading,
      "rightLoading": _vm.isDeleteDialogLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.deleteBooking
    }
  }, [(_vm$booking10 = _vm.booking) !== null && _vm$booking10 !== void 0 && (_vm$booking10$custome = _vm$booking10.customerInformation) !== null && _vm$booking10$custome !== void 0 && _vm$booking10$custome.email && !_vm.bookingCancelled ? _c('v-switch', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.notifyUser'),
      "inset": ""
    },
    model: {
      value: _vm.notifyUserForDelete,
      callback: function callback($$v) {
        _vm.notifyUserForDelete = $$v;
      },
      expression: "notifyUserForDelete"
    }
  }) : _vm._e()], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isUpdateDialogActive,
      "title": _vm.$t('components.booking.BookingDetailCard.confirmUpdateTitle'),
      "subtitle": _vm.$t('components.booking.BookingDetailCard.confirmUpdateSubtitle'),
      "leftLoading": _vm.isUpdateDialogLoading,
      "rightLoading": _vm.isUpdateDialogLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isUpdateDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isUpdateDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isUpdateDialogActive = false;
      },
      "rightClick": _vm.updateBooking
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t('components.booking.BookingDetailCard.notifyUser'),
      "inset": ""
    },
    model: {
      value: _vm.notifyUserForUpdate,
      callback: function callback($$v) {
        _vm.notifyUserForUpdate = $$v;
      },
      expression: "notifyUserForUpdate"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }